import { FC, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "../app/hooks"
import { resetStore } from "../app/store"
import { useAuthStatus } from "../hooks/useAuthStatus"

export const SignOutPage: FC = () => {
  // sign out from current auth provider when navigating to this page
  const { signOut } = useAuthStatus()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  useEffect(() => {
    localStorage.removeItem("tenantId")
    dispatch(resetStore())
    signOut().then(() => navigate("/"))
  }, [dispatch, navigate, signOut])
  return <>Signing out...</>
}
